import React from "react";

export default function Link({ icon, label, ...rest }) {
  return (
    <div>
      <a {...rest}><i className={icon}></i> {label}</a>
    </div>
  );
}
